import { defineMessage } from 'react-intl';

export const orderCommonI18n = {
  /* Order type */
  manual: defineMessage({
    id: 'common:order.manual',
    defaultMessage: 'Manual order'
  }),
  online: defineMessage({
    id: 'common:order.online',
    defaultMessage: 'Online order'
  }),

  /* Order status */
  cancelled: defineMessage({
    id: 'common:order.cancelled',
    defaultMessage: 'Cancelled'
  }),
  outstanding: defineMessage({
    id: 'common:order.outstanding',
    defaultMessage: 'Outstanding'
  }),
  paid: defineMessage({
    id: 'common:order.paid',
    defaultMessage: 'Paid'
  }),
  paidDeposit: defineMessage({
    id: 'common:order.paid-deposit',
    defaultMessage: 'Paid deposit'
  }),
  partiallyCancelled: defineMessage({
    id: 'common:order.partially-cancelled',
    defaultMessage: 'Partially cancelled'
  }),
  unpaid: defineMessage({
    id: 'common:order.unpaid',
    defaultMessage: 'Unpaid'
  }),

  /* Order summary */
  balanceAmount: defineMessage({
    id: 'common:order.balance-amount',
    defaultMessage: 'Balance due'
  }),
  depositAmount: defineMessage({
    id: 'common:order.deposit-amount',
    defaultMessage: 'Deposit'
  }),
  discountAmount: defineMessage({
    id: 'common:order.discount-amount',
    defaultMessage: 'Discount'
  }),
  dueNowAmount: defineMessage({
    id: 'common:order.due-now-amount',
    defaultMessage: 'Due now'
  }),
  netPaymentAmount: defineMessage({
    id: 'common:order.net-payment-amount',
    defaultMessage: 'Net payment'
  }),
  paidAmount: defineMessage({
    id: 'common:order.paid-amount',
    defaultMessage: 'Paid'
  }),
  paidByCustomerAmount: defineMessage({
    id: 'common:order.paid-by-customer-amount',
    defaultMessage: 'Paid by customer'
  }),
  pendingAmount: defineMessage({
    id: 'common:order.pending-amount',
    defaultMessage: 'Payment pending'
  }),
  refundedAmount: defineMessage({
    id: 'common:order.refunded-amount',
    defaultMessage: 'Refunded'
  }),
  subtotalAmount: defineMessage({
    id: 'common:order.subtotal-amount',
    defaultMessage: 'Subtotal'
  }),
  totalAmount: defineMessage({
    id: 'common:order.total-amount',
    defaultMessage: 'Total'
  }),

  /* Misc */
  awaitingRefund: defineMessage({
    id: 'common:order.awaiting-refund',
    defaultMessage: 'Awaiting refund'
  })
};
